import { useRef } from 'react';
import './ProductUpload.css';

function ProductUpload({ productImages, setProductImages }) {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      // Limit to 11 images as shown in the design
      const newImages = [...productImages, ...files].slice(0, 11);
      setProductImages(newImages);
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleRemoveImage = (index) => {
    const newImages = productImages.filter((_, i) => i !== index);
    setProductImages(newImages);
  };

  const renderImageSlots = () => {
    const slots = [];
    const totalSlots = 11;

    for (let i = 0; i < totalSlots; i++) {
      if (i < productImages.length) {
        const imageUrl = URL.createObjectURL(productImages[i]);
        slots.push(
          <div key={i} className="product-slot filled" onClick={() => handleRemoveImage(i)}>
            <img src={imageUrl} alt={`Product ${i + 1}`} className="product-image" />
            <div className="remove-overlay">
              <span className="remove-icon">✕</span>
            </div>
          </div>
        );
      } else {
        slots.push(
          <div key={i} className="product-slot empty"></div>
        );
      }
    }

    return slots;
  };

  return (
    <div className="upload-section jewelry-upload">
      <h2 className="section-title">Jewellery</h2>
      <button className="upload-button" onClick={handleClick}>
        <span className="upload-icon">⬆</span>
        Upload Multiple Photos
      </button>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept="image/*"
        multiple
        style={{ display: 'none' }}
      />
      <div className="product-grid">
        {renderImageSlots()}
      </div>
    </div>
  );
}

export default ProductUpload;
